export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14246.8f611b27.jpg";